import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  Avatar,
  Chip,
  useTheme,
  useMediaQuery,
  Fade,
  Slide,
  IconButton,
  AppBar,
  Toolbar,
  Stack,
  Rating,
  Divider
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { 
  ArrowForward, 
  Security, 
  Speed, 
  Palette, 
  CloudUpload,
  Download,
  Star,
  CheckCircle,
  PlayArrow,
  Menu,
  Close
} from '@mui/icons-material';
import tokens from '../../theme/tokens';
import Hero from './sections/Hero';
import Features from './sections/Features';
import HowItWorks from './sections/HowItWorks';
import Templates from './sections/Templates';
import Pricing from './sections/Pricing';
import FAQ from './sections/FAQ';
import Footer from './sections/Footer';
import Navigation from './components/Navigation';
import './LandingPage.css';

const LandingPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleGetStarted = () => {
    navigate('/app');
  };

  return (
      <Box sx={{ 
        minHeight: '100vh',
        background: tokens.colors.background.gradient,
        overflow: 'hidden'
      }}>
        {/* Navigation */}
        <Navigation 
          onGetStarted={handleGetStarted}
          mobileMenuOpen={mobileMenuOpen}
          setMobileMenuOpen={setMobileMenuOpen}
        />

        {/* Hero Section */}
        <Hero onGetStarted={handleGetStarted} />

        {/* Features Section */}
        <Features />

        {/* How It Works Section */}
        <HowItWorks onGetStarted={handleGetStarted} />

        {/* Templates Section */}
        <Templates onGetStarted={handleGetStarted} />

        {/* Pricing Section */}
        <Pricing onGetStarted={handleGetStarted} />

        {/* FAQ Section */}
        <FAQ />

        {/* Footer */}
        <Footer onGetStarted={handleGetStarted} />
      </Box>
  );
};

export default LandingPage; 